import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Backoffice/Button';
import * as styles from './FooterLayout.scss';

var FooterLayout = function FooterLayout(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      cancelText = _ref.cancelText,
      onCancel = _ref.onCancel,
      onOk = _ref.onOk,
      confirmText = _ref.confirmText,
      buttonsHeight = _ref.buttonsHeight,
      enableOk = _ref.enableOk,
      enableCancel = _ref.enableCancel;


  return React.createElement(
    'div',
    { className: styles.footer, 'data-hook': 'message-box-footer' },
    children,
    React.createElement(
      'div',
      { className: styles.footerbuttons },
      cancelText ? React.createElement(
        Button,
        { disabled: !enableCancel, height: buttonsHeight, theme: 'empty' + theme, onClick: onCancel, dataHook: 'cancellation-button' },
        cancelText
      ) : null,
      React.createElement(
        Button,
        { disabled: !enableOk, height: buttonsHeight, theme: 'full' + theme, onClick: onOk, dataHook: 'confirmation-button' },
        confirmText
      )
    )
  );
};

FooterLayout.propTypes = {
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
  enableOk: PropTypes.bool,
  enableCancel: PropTypes.bool,
  theme: PropTypes.string,
  buttonsHeight: PropTypes.string,
  children: PropTypes.any
};

FooterLayout.defaultProps = {
  theme: 'blue',
  buttonsHeight: 'small',
  enableOk: true,
  enableCancel: true
};

export default FooterLayout;
//# sourceMappingURL=FooterLayout.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/MessageBox/FooterLayout.js